/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { QueryClient, QueryKey, UseSuspenseQueryOptions, UseSuspenseQueryResult } from '@tanstack/react-query';
import { queryOptions, useSuspenseQuery } from '@tanstack/react-query';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import fetch from '../../client.ts';
import { getInvestmentDetailsQueryResponseSchema } from '../schemas/getInvestmentDetailsSchema.ts';
import type { GetInvestmentDetails505, GetInvestmentDetailsQueryResponse } from '../types/GetInvestmentDetails.ts';

export const getInvestmentDetailsSuspenseQueryKey = () => ['USER_BACKEND', { url: '/investment_details' }] as const;

export type GetInvestmentDetailsSuspenseQueryKey = ReturnType<typeof getInvestmentDetailsSuspenseQueryKey>;

/**
 * {@link /investment_details}
 */
export async function getInvestmentDetailsSuspense(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<GetInvestmentDetailsQueryResponse, ResponseErrorConfig<GetInvestmentDetails505>, unknown>({
    method: 'GET',
    url: `/investment_details`,
    ...requestConfig,
  });
  return getInvestmentDetailsQueryResponseSchema.parse(res.data);
}

export function getInvestmentDetailsSuspenseQueryOptions(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const queryKey = getInvestmentDetailsSuspenseQueryKey();
  return queryOptions<
    GetInvestmentDetailsQueryResponse,
    ResponseErrorConfig<GetInvestmentDetails505>,
    GetInvestmentDetailsQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getInvestmentDetailsSuspense(config);
    },
  });
}

/**
 * {@link /investment_details}
 */
export function useGetInvestmentDetailsSuspense<
  TData = GetInvestmentDetailsQueryResponse,
  TQueryKey extends QueryKey = GetInvestmentDetailsSuspenseQueryKey,
>(
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetInvestmentDetailsQueryResponse,
        ResponseErrorConfig<GetInvestmentDetails505>,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? getInvestmentDetailsSuspenseQueryKey();

  const query = useSuspenseQuery(
    {
      ...getInvestmentDetailsSuspenseQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient
  ) as UseSuspenseQueryResult<TData, ResponseErrorConfig<GetInvestmentDetails505>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
